import React from 'react';

//Loader template used thorughout the application
class LoaderOverlay extends React.Component {
    static get defaultProps() {
        return {
            active: false
        };
    }

    render() {
        return this.props.active && (
            <div className="loader-wrapper">
                <div className="loader-overlay">
                </div>
                <Loader />
            </div>
        )
    }
}

const Loader = () => {
    return (
        <div className="la-line-scale-pulse-out">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
        </div>
        // <img src={logo} alt="Loading..." />
    )
}

export default LoaderOverlay;